export default theme => ({

  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',

    [theme.breakpoints.up('lg')]: {
      marginLeft: theme.spacing.unit * 34
    }
  }

})



// WEBPACK FOOTER //
// ./src/styles/pages/dashboard.js